import http, { apiErrorMessage } from "../../http";
import {
    obtenerTokenWeb, borrarTokenWeb, ACCION_INTENTO_ENTREGA, ACCION_SOLICITUD_DEVOLUCION
} from "../../push/firebaseMessaging";

const vRutaNotificaciones = "notificaciones/";
const vRutaAutorizar = "autorizar/";
const LS_TOKEN = "fcmWebToken";

// Total de intentos de entrega de HOY visibles para el usuario (su sucursal; matriz
// todos) para la campanita: UNA consulta al cargar el dashboard y otra al llegar un
// push con el modulo abierto (resincroniza); las altas llegan por push (sin polling).
export const getIntentosTotal = () => {
    return (dispatch, getState) => {
        http.get(vRutaAutorizar + "intentos/total")
            .then(function (response) {
                // Envelope v1: {data:{total}}
                dispatch({ type: "NOTIF_TOTAL_SUCCESS", payload: { total: response.data.data.total } });
            })
            .catch(function (error) {
                dispatch({ type: "NOTIF_ERROR", payload: { error: apiErrorMessage(error) } });
            });
    };
};

// Obtiene el token FCM Web del navegador (pide permiso la primera vez) y lo
// registra en el API de logistica, que lo asocia a la sucursal del JWT (asi el
// API EAD avisa a la sucursal del chofer y a matriz). Para TODO usuario logueado.
// Best-effort: sin permiso o sin soporte, nada.
export const registrarTokenWeb = (pedirPermiso) => {
    return (dispatch, getState) => {
        obtenerTokenWeb(pedirPermiso !== false)
            .then(function (token) {
                if (!token) {
                    dispatch({ type: "NOTIF_TOKEN_NO_DISPONIBLE" });
                    return;
                }
                return http.post(vRutaNotificaciones + "web-token", { token, userAgent: navigator.userAgent })
                    .then(function () {
                        try { localStorage.setItem(LS_TOKEN, token); } catch (e) { /* sin storage */ }
                        dispatch({ type: "NOTIF_TOKEN_REGISTRADO", payload: { token } });
                    });
            })
            .catch(function (error) {
                dispatch({ type: "NOTIF_ERROR", payload: { error: apiErrorMessage(error) } });
            });
    };
};

// Borra el token del navegador en el API (DELETE, mientras el JWT sigue vivo) y
// lo invalida en FCM. Devuelve una promesa que SIEMPRE resuelve: el logout no
// debe quedarse esperando por esto.
export const eliminarTokenWeb = () => {
    return (dispatch, getState) => {
        let token = null;
        try { token = localStorage.getItem(LS_TOKEN); } catch (e) { /* sin storage */ }
        const enApi = token
            ? http.delete(vRutaNotificaciones + "web-token", { data: { token } }).catch(function () { })
            : Promise.resolve();
        const timeout = new Promise(function (resolve) { setTimeout(resolve, 1500); });
        return Promise.race([Promise.all([enApi, borrarTokenWeb()]), timeout]).then(function () {
            try { localStorage.removeItem(LS_TOKEN); } catch (e) { /* sin storage */ }
            dispatch({ type: "NOTIF_TOKEN_ELIMINADO" });
        });
    };
};

// Item de la campanita a partir del `data` (todo string) de un push; null si la
// accion no es de este modulo. Ids: 'i{intento_id}' para los intentos (no chocan
// con los numericos de las solicitudes legadas en la lista de recientes).
const avisoDesdePush = (data) => {
    if (!data) {
        return null;
    }
    if (data.accion === ACCION_INTENTO_ENTREGA) {
        // Contrato del API EAD (NotificacionIntentoEntregaService): intento_id, guia, numero,
        // maximo, chofer, sucursal, nombresucursal, unidad, folioreparto, motivo, fecha, titulo, cuerpo
        const numero = parseInt(data.numero, 10) || 0;
        const maximo = parseInt(data.maximo, 10) || 2;
        return {
            id: data.intento_id ? "i" + data.intento_id : "",
            tipo: "intento",
            accion: data.accion,
            guia: data.guia || "",
            numero: numero,
            maximo: maximo,
            chofer: data.chofer || "",
            unidad: data.unidad || "",
            folioreparto: data.folioreparto || "",
            nombresucursal: data.nombresucursal || "",
            motivo: data.motivo || "",
            fecha: data.fecha || "",
            titulo: data.titulo || ("Intento de entrega " + numero + " de " + maximo),
            cuerpo: data.cuerpo || "",
            recibida: Date.now(),
        };
    }
    if (data.accion === ACCION_SOLICITUD_DEVOLUCION) {
        // aviso legado de solicitud de devolucion (app vieja): se conserva el manejo
        return {
            id: parseInt(data.solicitud_id, 10) || 0,
            tipo: "solicitud",
            accion: data.accion,
            guia: data.guia || "",
            tipo_solicitud: data.tipo || "REVERSION",
            chofer: data.chofer || "",
            nombresucursal: data.nombresucursal || "",
            unidad: data.unidad || "",
            folioreparto: data.folioreparto || "",
            motivo: data.motivo || "",
            fecha: data.fecha || "",
            titulo: data.titulo || "Solicitud de devolución pendiente",
            cuerpo: data.cuerpo || "",
            recibida: Date.now(),
        };
    }
    return null;
};

// Push recibido en primer plano (onMessage). Se atienden el aviso de intento de
// entrega y el legado de solicitud de devolucion; el resto se ignora.
export const pushRecibido = (data) => {
    return (dispatch, getState) => {
        const aviso = avisoDesdePush(data);
        if (aviso == null) {
            return;
        }
        dispatch({ type: "NOTIF_NUEVO_AVISO", payload: { aviso } });
    };
};

// El usuario abrio la campanita / entro al modulo: se apagan los "no vistos".
export const marcarVistas = () => {
    return (dispatch, getState) => {
        dispatch({ type: "NOTIF_MARCAR_VISTAS" });
    };
};

export const cerrarAviso = () => {
    return (dispatch, getState) => {
        dispatch({ type: "NOTIF_CERRAR_AVISO" });
    };
};

export const closeMessages = () => {
    return (dispatch, getState) => {
        dispatch({ type: "NOTIF_CLOSE_MESSAGES" });
    };
};
